import { useNavigate } from "react-router-dom";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Check } from "lucide-react";

const PERKS = [
  "Analyses de courriers illimitées",
  "Coffre-fort illimité + vérification IA",
  "Courriers illimités & export PDF",
  "Lecture à voix haute",
  "Explication multilingue",
  "Assistant Impôts complet & dossier assemblé",
];

export function PaywallDialog({ open, onOpenChange, reason }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="paywall-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 h-14 w-14 rounded-2xl bg-brand/10 flex items-center justify-center">
            <Crown className="h-7 w-7 text-brand" />
          </div>
          <DialogTitle className="text-center font-heading text-2xl">
            Passez en Premium
          </DialogTitle>
          <DialogDescription className="text-center">
            {reason || "Vous avez atteint la limite de l'offre gratuite."}
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 my-2">
          {PERKS.map((p) => (
            <li key={p} className="flex items-start gap-2 text-sm">
              <Check className="h-4 w-4 text-success shrink-0 mt-0.5" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
        <Button
          className="w-full rounded-full h-12 text-base bg-brand hover:bg-brand/90"
          onClick={() => { onOpenChange(false); navigate("/app/abonnement"); }}
          data-testid="paywall-cta"
        >
          Voir les offres
        </Button>
      </DialogContent>
    </Dialog>
  );
}
